import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EVO_META, fmtDate } from '../constants';

// Quiet dashboard glance: what have I actually been working on lately?
export default function RecentActivity({ events = [], t, locale }) {
  const navigate = useNavigate();
  if (events.length === 0) return null;
  return (
    <section className="crs-section crs-activity" data-testid="creator-recent-activity">
      <p className="crs-section__label">{t.cr_recent_activity || 'Recent activity'}</p>
      <div className="crs-activity__list">
        {events.map((e, i) => {
          const meta = EVO_META[e.kind] || EVO_META.note;
          return (
            <button
              key={`${e.item_id}-${e.at}-${i}`}
              type="button"
              className="crs-timeline__event"
              data-testid={`creator-activity-${i}`}
              onClick={() => navigate(`/creator/item/${e.item_id}`)}
            >
              <span className="crs-timeline__time">{fmtDate(e.at, locale)}</span>
              <span className={`crs-evo__symbol is-${e.kind}`}>{meta.symbol}</span>
              <span className="crs-timeline__body">
                <em>{t[meta.labelKey] || e.kind}</em>
                {' \u2014 '}
                {e.kind === 'created' ? e.item_title : (e.text || e.item_title)}
                {e.kind !== 'created' && e.text && e.text !== e.item_title && (
                  <span className="crs-timeline__source"> · {e.item_title}</span>
                )}
              </span>
            </button>
          );
        })}
      </div>
      <button
        type="button"
        className="crs-activity__more"
        onClick={() => navigate('/creator/timeline')}
        data-testid="creator-link-timeline"
      >
        {t.cr_your_timeline || 'Your timeline'} →
      </button>
    </section>
  );
}
